// extracted by mini-css-extract-plugin
module.exports = {"pill":"pill_pill__30JZ1","pillItem":"pill_pillItem__GlLtm"};